<template lang="pug">
div
  re-stories

  v-container.mt-1.mt-md-3.mb-3
    re-full-screen-banners

    re-shift

    // Костыль для AppStore проверки
    re-miniapps(v-if="user.phone !== '+77777777777'")

    re-partners

    re-promotions

  re-anketolog

  re-rek-ofd-payment-notifier(v-if="cashRegister.fdo === 'REK'")

  re-test-version-warning(v-if="$isTestMode()")

</template>
<script>
import { mapActions, mapState } from 'vuex'
import FullScreenBanners from './parts/FullScreenBanners.vue'
import Stories from './parts/Stories.vue'
import Shift from './parts/Shift.vue'
import MiniApps from './parts/MiniApps.vue'
import Promotions from './parts/Promotions.vue'
import Anketolog from './parts/Anketolog.vue'
import Partners from './parts/Partners.vue'
import REKOFDPaymentNotifier from '../utils/REKOFDPaymentNotifier.vue'
import TestVersionWarning from '../utils/TestVersionWarning.vue'

export default {
  components: {
    're-stories': Stories,
    're-full-screen-banners': FullScreenBanners,
    're-shift': Shift,
    're-miniapps': MiniApps,
    're-partners': Partners,
    're-promotions': Promotions,
    're-anketolog': Anketolog,
    're-rek-ofd-payment-notifier': REKOFDPaymentNotifier,
    're-test-version-warning': TestVersionWarning,
  },

  computed: {
    ...mapState({
      cashRegister: state => state.cashRegisters.cashRegister.cashRegister,
      user: state => state.auth.user,
    }),
  },

  mounted() {
    this.analyticsLogEvent({ eventName: 're_dash_opened' })
  },

  methods: {
    ...mapActions({
      analyticsLogEvent: 'analytics/logEvent',
    }),
  },
}
</script>
<style scoped lang="stylus">
</style>
